"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var EditOutline_1 = __importDefault(require("../icons/generated/EditOutline"));
var translations_context_1 = __importDefault(require("../../context/translations/translations.context"));
var styled_components_1 = __importDefault(require("styled-components"));
var button_component_1 = __importDefault(require("../inputs/button.component"));
var text_field_component_1 = __importDefault(require("../inputs/text-field.component"));
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 18px;\n  font-weight: bold;\n  flex-grow: 1;\n"], ["\n  color: ", ";\n  font-size: 18px;\n  font-weight: bold;\n  flex-grow: 1;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colours.global.lightWhite;
});
Container.displayName = 'Container';
var EditContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  gap: 8px;\n  width: 100%;\n"], ["\n  display: flex;\n  gap: 8px;\n  width: 100%;\n"])));
EditContainer.displayName = 'EditContainer';
var Placeholder = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-weight: normal;\n  font-style: italic;\n"], ["\n  font-weight: normal;\n  font-style: italic;\n"])));
Placeholder.displayName = 'Placeholder';
var StyledEditIcon = styled_components_1.default(EditOutline_1.default)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 16px;\n  height: 16px;\n  fill: ", ";\n  position: relative;\n  cursor: pointer;\n  margin-left: 8px;\n  top: 3px;\n"], ["\n  width: 16px;\n  height: 16px;\n  fill: ", ";\n  position: relative;\n  cursor: pointer;\n  margin-left: 8px;\n  top: 3px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colours.global.lightWhite;
});
StyledEditIcon.displayName = 'StyledEditIcon';
var EditableLabel = function (_a) {
    var placeholder = _a.placeholder, label = _a.label, onChange = _a.onChange;
    var _b = react_1.useState(label || ''), labelValue = _b[0], setLabel = _b[1];
    var _c = react_1.useState(false), editMode = _c[0], setEditMode = _c[1];
    var getTranslation = react_1.useContext(translations_context_1.default).getTranslation;
    react_1.useEffect(function () {
        if (label)
            setLabel(label);
    }, [label]);
    var save = function () {
        onChange(labelValue);
        setEditMode(false);
    };
    return (react_1.default.createElement(Container, { "data-test-id": 'editable-label' },
        !label && !editMode && react_1.default.createElement(Placeholder, null, placeholder),
        label && !editMode && react_1.default.createElement("span", null, label),
        !editMode && react_1.default.createElement(StyledEditIcon, { "data-test-id": 'edit-label-icon', onClick: function () { return setEditMode(true); } }),
        editMode && (react_1.default.createElement(EditContainer, null,
            react_1.default.createElement(text_field_component_1.default, { testID: 'editable-label-text-field', id: 'label', value: labelValue, onChange: function (value) { return setLabel(value); } }),
            react_1.default.createElement(button_component_1.default, { testID: 'edit-label-cancel', onClick: function () { return setEditMode(false); } }, getTranslation('GLOBAL:CANCEL')),
            react_1.default.createElement(button_component_1.default, { testID: 'edit-label-ok', onClick: save }, getTranslation('GLOBAL:OK'))))));
};
EditableLabel.displayName = 'EditableLabel';
exports.default = EditableLabel;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
